// ─── i18n bootstrap ─────────────────────────────────────────────────────────
//
// This is the app's single i18next initialisation. It is imported once for
// its side effect from the app entry (`src/index.js`) BEFORE React renders, so
// `useTranslation()` / `t()` work everywhere from the first paint.
//
// Scope today: English-only. The framework is wired end-to-end (catalog +
// `initReactI18next`), and the first surfaces actually driven through it are
// the admin **Cards & Stacks** and **Scene Recording** sections (keys under
// `admin.cardsStacks.*` and `admin.sceneRecording.*`). Everything else still
// uses hard-coded copy and can be migrated incrementally onto the same catalog.
//
// `useSuspense: false` — react-i18next can otherwise suspend the tree while a
// translation backend loads. We ship resources inline (synchronous), so there
// is nothing to wait on, but disabling Suspense removes any blank-screen risk
// if a key/namespace is ever resolved lazily.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en";

export const DEFAULT_LANGUAGE = "en";

// Guard against double-init (e.g. Fast Refresh / a stray second import).
if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    // We control the keys; surface missing ones in dev instead of failing.
    returnNull: false,
    interpolation: {
      // React already escapes rendered values — double-escaping would mangle
      // legitimate characters in interpolated names.
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
}

export default i18n;
